import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import VectorLoader from './VectorLoader';
import { useTheme } from '../hooks/useTheme';
import useSectionAnimation from 'hooks/animations/useSectionAnimation';
import { renderWithLineBreaks } from 'utils/renderWithLineBreaks';
import { markHomeHeroImageReady, resetHomeHeroImageReady } from 'utils/helpers';

const BBHeroSection = ({ data, loaderProgress, isLoading }) => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();

  const backgroundRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const buttonRef = useRef(null);

  const { canReveal, isImageLoaded, backgroundImageUrl } = useSectionAnimation({
    backgroundRef,
    titleRef,
    descriptionRef,
    buttonRef,
    imageUrl: isDarkMode
      ? data?.darkModeImageUrl || data?.lightModeImageUrl
      : data?.lightModeImageUrl,
    lqip: isDarkMode
      ? data?.darkModeImageLqip || data?.lightModeImageLqip
      : data?.lightModeImageLqip,
    isLoading,
  });

  useEffect(() => {
    if (canReveal) {
      markHomeHeroImageReady();
    }
    return () => {
      resetHomeHeroImageReady();
    };
  }, [canReveal]);

  return (
    <div className='relative background-section-container overflow-hidden full-pager'>
      <div
        className={`full-height full-width background-section absolute hero-blur-up ${
          isImageLoaded ? 'hero-blur-up-loaded' : ''
        }`}
        style={{
          backgroundImage: `url(${backgroundImageUrl})`,
        }}
        ref={backgroundRef}
      />
      <div className='hp-hero-section full-height full-width flex flex-column z-1'>
        <div className='half-hp-hero flex items-end'>
          <p
            ref={titleRef}
            className='img-page-font-grotesk font-white-color z-1'
          >
            {renderWithLineBreaks(data?.title)}
          </p>
        </div>
        <VectorLoader
          className={`${data?.description ? '' : 'absolute center-abs'}`}
          progress={loaderProgress}
        />
        <div className='half-hp-hero'>
          <div className='flex flex-column hp-hero-section-content'>
            <p
              ref={descriptionRef}
              className='paragraph-font-grotesk font-white-color'
            >
              {data?.description}
            </p>
            {data?.buttonText && data?.buttonLink && (
              <Button ref={buttonRef} onClick={() => navigate(data.buttonLink)}>
                {data.buttonText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BBHeroSection;
